import logo from './logo.svg';
import { Fragment, useEffect, useState } from "react";
import './assets/font-awesome.min.css'
import { useAppSelector } from './redux/hooks';
import DriverSummary from './components/driver/DriverSummary';
import ManagerSummary from './components/manager/ManagerSummary';
import { DmwaError } from "./models/DmwaError";
import { IsLoggedIn } from './redux/tokenSlice';
import { sortBy } from 'lodash';

const App = () => {

	const isLoggedIn = IsLoggedIn();

	const currentUser = useAppSelector(state => state.appState.currentUser);
	const currentOrganization = useAppSelector(state => state.appState.currentOrganization);
	const allGroups = useAppSelector(state => state.appState.userGroupMembership[currentUser?.userID ?? -1]);

	return (
		<div className="App">
			{ currentUser?.isInDriverRole === true ?
				 <DriverSummary currentUser={currentUser} currentOrganization={currentOrganization} />
				:
				<ManagerSummary currentUser={currentUser} currentOrganization={currentOrganization} allGroups={sortBy(allGroups, ['name'])}/>
			}

		</div>
	)
}

export default App;

